import { LogoutIcon, MenuAlt4Icon, UserIcon } from "@heroicons/react/solid";
import { useEffect, useState } from "react";
import profile from "../assets/images/profile.jpg";
import "./header.css";
import Dropdown from "./dropdown/Dropdown";
import { Link } from "react-router-dom";
import Cookies from "universal-cookie";
import {
  COMPANY_EMPLOYEE_ID,
  COMPANY_ID,
  COMPANY_NAME,
  COMPANYNAME,
  IS_CHAT,
  IS_HRMS,
  IS_LIVE_TRACKING,
  NAME,
  REDIRECT_URL,
  ROLE,
  SERVICE_KEY,
  TOKEN_NAME,
  USERNAME,
} from "../config";
import { Button } from "./ui";
import { getCookieDomain, setCookies } from "../utility";
import useGetUserCompanies from "../hooks/useGetUserCompanies";

import useAppBrandInfo from "../hooks/useAppBrandInfo";

const cookies = new Cookies();

function Header({ onMenuClick, onProfileClick }) {
  const brandInfo = useAppBrandInfo();
  const [isShowDropDown, setIsShowDropDown] = useState(false);

  const handleMenuToggle = () => {
    onMenuClick();
    setIsShowDropDown(false);
  };

  const handleProfileToggle = () => {
    setIsShowDropDown(!isShowDropDown);
    onProfileClick();
  };

  const [name, setName] = useState("");
  const [userRole, setUserRole] = useState("");
  const [companyName, setCompanyName] = useState("");
  const { userCompaniesList } = useGetUserCompanies();

  const handleLogout = () => {
    const cookieNames = [
      TOKEN_NAME,
      COMPANYNAME,
      NAME,
      COMPANY_ID,
      ROLE,
      USERNAME,
      COMPANY_EMPLOYEE_ID,
      IS_LIVE_TRACKING,
      IS_CHAT,
      IS_HRMS,
    ];

    const baseOptions = {
      path: "/",
      domain: getCookieDomain(),
      secure: window.location.protocol === "https:",
      sameSite: "lax",
    };

    for (let i = 0; i < cookieNames.length; i++) {
      cookies.remove(cookieNames[i], baseOptions);
    }

    localStorage.clear();
    window.location.href = `${REDIRECT_URL}?pid=${SERVICE_KEY}`;
  };

  useEffect(() => {
    setName(cookies.get("_am_name"));
    setUserRole(cookies.get(ROLE));
    setCompanyName(cookies.get(COMPANYNAME) || "");
  }, []);

  return (
    <>
      <div className="text-black bg-white h-16 px-4 fixed top-0 mb-4 z-[1001] w-full shadow-lg flex items-center justify-between">
        <Link to="/" className="flex items-center shrink-0">
          <img
            src={brandInfo.app_logo_url || "/idom_logo.webp"}
            alt={`${brandInfo.app_name || "iDOfficeMate"} Logo`}
            className="h-10 w-auto md:h-12 object-contain"
          />
        </Link>
        <div className="flex items-center justify-between h-full">
          <div className="flex items-center gap-2">
            <div className="relative lg:hidden">
              <Button
                variant={"ghost"}
                onClick={handleProfileToggle}
                onMouseDown={(e) => e.stopPropagation()}
                className="text-sm font-semibold text-gray-700 bg-gray-50 hover:bg-gray-100 px-3 py-1.5 rounded-lg flex items-center gap-1.5"
              >
                <span>{companyName || "Select"}</span>
                <UserIcon className="w-4 h-4 shrink-0 text-gray-500" />
              </Button>

              {isShowDropDown && (
                <Dropdown
                  show={isShowDropDown}
                  className={
                    "top-14 right-2 bg-white w-[16rem] shadow-2xl px-2 py-4 rounded-xl border border-gray-100"
                  }
                >
                  <ul className="space-y-4">
                    {userCompaniesList?.data?.data && userCompaniesList.data.data.length > 0 && (
                      <>
                        <li className="px-2 font-semibold text-gray-400 text-xs uppercase tracking-wider mb-2">
                          My Companies
                        </li>
                        <div className="max-h-[10rem] overflow-y-auto space-y-1 mb-2 pr-1">
                          {userCompaniesList.data.data.map((company, idx) => {
                            const isCurrent = cookies.get(COMPANY_ID) === company.company_id;
                            return (
                              <li
                                key={`${company.company_id}-${idx}`}
                                onClick={() => {
                                  setCookies({
                                    [COMPANY_ID]: company.company_id,
                                    [COMPANYNAME]: company.company_name,
                                    [COMPANY_EMPLOYEE_ID]: company.company_employee_id,
                                  });
                                }}
                                className={`px-2 py-1.5 rounded-lg text-sm cursor-pointer transition-colors duration-150 block truncate ${
                                  isCurrent
                                    ? "bg-blue-50 text-blue-600 font-semibold"
                                    : "text-gray-700 hover:bg-gray-100"
                                }`}
                              >
                                <a href="/" className="block truncate">
                                  {company.company_name}
                                </a>
                              </li>
                            );
                          })}
                        </div>
                        <hr className="my-2 border-gray-100" />
                      </>
                    )}
                    {userRole === "EMPLOYEE" && (
                      <li
                        className="flex text-dark cursor-pointer"
                        onClick={() => setIsShowDropDown(false)}
                      >
                        <UserIcon className="w-6" />
                        <Link to="/my-account" className="ml-3">
                          My Account
                        </Link>
                      </li>
                    )}
                    <li
                      className="flex text-dark cursor-pointer"
                      onClick={handleLogout}
                    >
                      <LogoutIcon className="w-6" />
                      <span className="ml-3">Logout</span>
                    </li>
                  <li className="pt-3 border-t border-gray-100 flex items-center justify-between text-xs text-gray-400"><span>{brandInfo.app_name} {brandInfo.product_name}</span><span>{brandInfo.product_version}</span></li></ul>
                </Dropdown>
              )}
            </div>

            <div className="block lg:hidden">
              <Button
                size={"icon"}
                variant={"ghost"}
                onClick={handleMenuToggle}
                onMouseDown={(e) => e.stopPropagation()}
              >
                <MenuAlt4Icon className="w-6 h-6" />
              </Button>
            </div>
          </div>
          <div className="relative hidden lg:block">
            <div
              onClick={handleProfileToggle}
              onMouseDown={(e) => e.stopPropagation()}
              className="cursor-pointer flex items-center bg-gray-50 hover:bg-gray-100 px-4 py-2 rounded-xl transition-all duration-150 border border-gray-100"
            >
              <span className="font-semibold text-gray-800 mr-2">
                {companyName || "Select Company"}
              </span>
              <UserIcon className="w-5 h-5 text-gray-500" />
            </div>
            {isShowDropDown ? (
              <Dropdown
                show={isShowDropDown}
                className={
                  "top-14 right-0 w-[16rem] bg-white shadow-2xl px-2 py-4 rounded-xl border border-gray-100"
                }
              >
                <ul className="space-y-4">
                  {userCompaniesList?.data?.data && userCompaniesList.data.data.length > 0 && (
                    <>
                      <li className="px-2 font-semibold text-gray-400 text-xs uppercase tracking-wider mb-2">
                        My Companies
                      </li>
                      <div className="max-h-[10rem] overflow-y-auto space-y-1 mb-2 pr-1">
                        {userCompaniesList.data.data.map((company, idx) => {
                          const isCurrent = cookies.get(COMPANY_ID) === company.company_id;
                          return (
                            <li
                              key={`${company.company_id}-${idx}`}
                              onClick={() => {
                                setCookies({
                                  [COMPANY_ID]: company.company_id,
                                  [COMPANYNAME]: company.company_name,
                                  [COMPANY_EMPLOYEE_ID]: company.company_employee_id,
                                });
                              }}
                              className={`px-2 py-1.5 rounded-lg text-sm cursor-pointer transition-colors duration-150 block truncate ${
                                isCurrent
                                  ? "bg-blue-50 text-blue-600 font-semibold"
                                  : "text-gray-700 hover:bg-gray-100"
                              }`}
                            >
                              <a href="/" className="block truncate">
                                {company.company_name}
                              </a>
                            </li>
                          );
                        })}
                      </div>
                      <hr className="my-2 border-gray-100" />
                    </>
                  )}
                  {userRole === "EMPLOYEE" && (
                    <li
                      className="flex text-dark cursor-pointer"
                      onClick={() => setIsShowDropDown(false)}
                    >
                      <UserIcon className=" w-6" />
                      <Link to="/my-account" className=" ml-3">
                        My Account
                      </Link>
                    </li>
                  )}
                  <li
                    className="flex text-dark cursor-pointer"
                    onClick={handleLogout}
                  >
                    <LogoutIcon className=" w-6" />
                    <span className=" ml-3">Logout</span>
                  </li>
                <li className="pt-3 border-t border-gray-100 flex items-center justify-between text-xs text-gray-400"><span>{brandInfo.app_name} {brandInfo.product_name}</span><span>{brandInfo.product_version}</span></li></ul>
              </Dropdown>
            ) : null}
          </div>
        </div>
      </div>
    </>
  );
}

export default Header;
